
import { Input } from "../ui/input";

interface LeadFormInputProps {
  type: "email" | "tel" | "text";
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

const LeadFormInput = ({ type, placeholder, value, onChange, required }: LeadFormInputProps) => (
  <Input
    type={type}
    placeholder={placeholder}
    className="bg-white/5 border-white/10 text-white placeholder:text-white/60"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    required={required}
  />
);

export default LeadFormInput;
